import { RouteConfig } from 'vue-router';
// models
import Breadcrumbs from './breadcrumbs';

const Home = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "FurijatVerification" */ '@/views/Index');
const FurijatVerification = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "FurijatVerification" */ '@/views/Verification/verification');

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/furijat-verification',
    name: 'FurijatVerification',
    component: FurijatVerification,
    meta: {
      breadcrumb: Breadcrumbs.verifications,
      highlighted: true,
      pageTitle: 'furizatBillsVerification',
      pageDescription: 'verificationServiceDescription',
    },
  },
];

export default routes;
